const INITIAL_MONEY = 10;
const INITIAL_BID = 1;
const SLOTS_OPTIONS: string[] = ['🏈', '🎱', '🥎', '⚽️', '🏀', '🏐', '⚾️'];

export { INITIAL_MONEY, INITIAL_BID, SLOTS_OPTIONS };
